export const DEFAULT_NOTIFICATION_ICON = "mdi mdi-bell-ring-outline";

export const NOTIFICATION_TYPE_ICONS: Record<string, string> = {
    order: "mdi mdi-cart-outline",
    success: "mdi mdi-check-circle-outline",
    warning: "mdi mdi-alert-circle-outline",
    error: "mdi mdi-close-circle-outline",
    info: "mdi mdi-information-outline",
    promotion: "mdi mdi-tag-outline",
    system: "mdi mdi-bullhorn-outline",
    service_call: "mdi mdi-headset",
    order_status: "mdi mdi-clipboard-text-outline",
};
